// Angular
import { Injectable } from '@angular/core';

// Libraries
import { BehaviorSubject } from 'rxjs';

// Models
import { AppCleanup } from '../../../models';

@Injectable({
	providedIn: 'root',
})
export class DynamicSideNavService extends AppCleanup {
	opened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() {
		super();
	}

	open() {
		this.opened.next(true);
	}

	close() {
		this.opened.next(false);
	}

	toggle() {
		let value = this.opened.getValue();
		this.opened.next(!value);
	}
}
